import { getFromStorage } from "../../utils/storageUtils";
import { ReportRequestDto } from "../../types/report.types";
import instance, { post } from "../../utils/BaseService";

export async function getReportSummary(dispatch: any, props: ReportRequestDto) {
  return await post(dispatch, '/report/getSummary', props);
}

export async function getMonthlyRevenue(dispatch: any, props: ReportRequestDto) {
  return await post(dispatch, '/report/getMonthlyRevenue', props);
}

export async function getInvoiceStatus(dispatch: any, props: ReportRequestDto) {
  return await post(dispatch, '/report/getInvoiceStatus', props);
}

export async function getTopClients(dispatch: any, props: ReportRequestDto) {
  return await post(dispatch, '/report/getTopClients', props);
}

export async function getTopItems(dispatch: any, props: ReportRequestDto) {
  return await post(dispatch, '/report/getTopItems', props);
}

export async function getDashboardData(dispatch: any, props: ReportRequestDto) {
  return await post(dispatch, '/report/getDashboardData', props);
}

export async function generateExcelReport(dispatch:any,props:ReportRequestDto,config = {}){
   const response = await instance.post('/report/export-excel', props, {
      headers: {
        access_token: localStorage.getItem("token")  || "",
        tenantId: localStorage.getItem("tenantId") || "",
      },
      ...config, // spread additional config (like responseType: 'blob')
    });
    return response.data;
}